export var nameof = function (name) { return name; };
